export enum FilterTypeFields {
  View = 'view',
  Project = 'projects',
  Workers = 'workers',
  Reset = 'reset',
  FromDate = 'fromTime',
  ToDate = 'toTime',
  Period = 'period',
  ShowFilters = 'showFilter',
  CopyWeek = 'copyWeek',
  ShowUnscheduled = 'showUnscheduled',
  Task = 'tasks',
  W_Client = 'w_clients',
  P_Client = 'p_clients',
  Sort = 'sort',
  Status = 'status',
  DisplayStatus = 'display_status[]'
}

export enum ProjectFilterTypeFields {
  Reset = 'reset',
  FromDate = 'fromTime',
  ToDate = 'toTime',
  Period = 'period',
  Client = 'clients',
  Sort = 'sort',
  Status = 'status'
}

export type FilterTypes =
  | FilterTypeFields.Project
  | FilterTypeFields.Workers
  | FilterTypeFields.FromDate
  | FilterTypeFields.ToDate
  | FilterTypeFields.Reset
  | FilterTypeFields.Period
  | FilterTypeFields.ShowFilters
  | FilterTypeFields.CopyWeek
  | FilterTypeFields.ShowUnscheduled
  | FilterTypeFields.Task
  | FilterTypeFields.W_Client
  | FilterTypeFields.P_Client
  | FilterTypeFields.View
  | FilterTypeFields.Sort;
